import { Layout } from 'antd';
import AppHeader from './Header';
import SideMenu from './SideMenu';

const { Content } = Layout;

const AppLayout = ({ children }) => {
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <SideMenu />
      <Layout>
        <AppHeader />
        <Content className="content-wrapper">{children}</Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
